<script setup lang="ts">
import { useSpotifyStore } from '../stores/spotify'

interface Props {
  /** Whether connecting is the screen's single gold action. */
  primary?: boolean
}

const props = withDefaults(defineProps<Props>(), { primary: true })

const spotify = useSpotifyStore()
</script>

<template>
  <div class="panel stack">
    <div class="spread">
      <h2 class="title-md">{{ $t('spotify.title') }}</h2>
      <span v-if="spotify.connected" class="badge badge--ok">
        {{ $t('spotify.connected') }}
      </span>
    </div>

    <template v-if="!spotify.connected">
      <p class="muted">{{ $t('spotify.connectBody') }}</p>
      <p class="hint">{{ $t('spotify.scopeHint') }}</p>
      <button
        type="button"
        class="btn btn--block"
        :class="props.primary ? 'btn--primary btn--cta' : ''"
        @click="spotify.connect()"
      >
        {{ $t('spotify.connect') }}
      </button>
    </template>

    <template v-else>
      <div
        v-if="spotify.needsPremium"
        class="panel panel--inset stack"
        style="--stack-gap: var(--space-2)"
      >
        <strong>{{ $t('spotify.premiumRequiredTitle') }}</strong>
        <p class="muted">{{ $t('spotify.premiumRequiredBody') }}</p>
      </div>
      <button type="button" class="btn btn--ghost btn--block" @click="spotify.disconnect()">
        {{ $t('spotify.disconnect') }}
      </button>
    </template>
  </div>
</template>
